import { createSvgIcon } from '@mui/material';

export const FinishedIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none">
    <path
      d="M0.949951 1V1.65M0.949951 14V10.1M0.949951 10.1H10.0313C10.4275 10.1 10.6663 9.66126 10.4513 9.32857L8.19846 5.84348C8.08452 5.66722 8.09279 5.43856 8.21916 5.27099L10.3458 2.45106C10.5943 2.12161 10.3592 1.65 9.9466 1.65H0.949951M0.949951 10.1V1.65"
      stroke="currentColor"
      stroke-linecap="round"
    />
  </svg>,
  'Finished',
);
